<div class="main-vehicle-card">
  <!-- Cabecera del Módulo -->
  <div class="module-header d-flex justify-content-between align-items-center">
    <div>
      <h2 class="module-title">{{ titulo }}</h2>
      <p class="module-subtitle">Siga los pasos para registrar un nuevo vehículo de la flota en la plataforma administrativamente</p>
    </div>
  </div>

  <!-- Stepper Asistente -->
  <div class="container-fluid p-0">
    <p-stepper [(activeStep)]="active" [linear]="true">
      
      <!-- PASO 1: Datos del Vehiculo -->
      <p-stepperPanel header="{{ step1_titulo }}">
        <ng-template pTemplate="content">
          <form (ngSubmit)="next()" [formGroup]="formVehiculo" class="mt-4">
            
            <!-- Tarjeta: Especificaciones Básicas -->
            <div class="detail-card">
              <h3 class="detail-card-title">
                <i class="pi pi-info-circle"></i> Especificaciones Básicas
              </h3>
              
              <div class="row">
                <!-- Placa -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Placa*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-id-card"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_plate"
                      placeholder="Ej: ABC-1234"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formVehiculo.controls['veh_plate'].hasError('required') && 
                      formVehiculo.controls['veh_plate'].touched
                    "
                  >
                    La placa es requerida.
                  </span>
                </div>

                <!-- Nro. Registro -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Nro. Registro*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-file"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_num_registration"
                      placeholder="Ingrese el nro de registro"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_num_registration'].hasError('required') && formVehiculo.controls['veh_num_registration'].touched) {
                    <span class="text-danger labelError">El número de registro es requerido.</span>
                  }
                  @if (formVehiculo.controls['veh_num_registration'].hasError('pattern') && formVehiculo.controls['veh_num_registration'].touched) {
                    <span class="text-danger labelError">El campo solo acepta números.</span>
                  }
                </div>
              </div>

              <div class="row">
                <!-- Marca -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Marca*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-tag"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_brand"
                      placeholder="Ej: Chevrolet, Hyundai, Renault"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_brand'].hasError('required') && formVehiculo.controls['veh_brand'].touched) {
                    <span class="text-danger labelError">La marca es requerida.</span>
                  }
                </div>

                <!-- Modelo -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Modelo*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-car"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_model"
                      placeholder="Ej: Logan, Accent, etc."
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_model'].hasError('required') && formVehiculo.controls['veh_model'].touched) {
                    <span class="text-danger labelError">El modelo es requerido.</span>
                  }
                </div>
              </div>
            </div>

            <!-- Tarjeta: Detalles Técnicos y Conductor -->
            <div class="detail-card">
              <h3 class="detail-card-title">
                <i class="pi pi-cog"></i> Detalles Técnicos y Conducción
              </h3>
              
              <div class="row">
                <!-- Año -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Año*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-calendar"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_anio"
                      placeholder="Ej: 2023"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_anio'].hasError('required') && formVehiculo.controls['veh_anio'].touched) {
                    <span class="text-danger labelError">El año es requerido.</span>
                  }
                  @if (formVehiculo.controls['veh_anio'].hasError('pattern') && formVehiculo.controls['veh_anio'].touched) {
                    <span class="text-danger labelError">El campo acepta solo números.</span>
                  }
                </div>

                <!-- Color -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Color*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-palette"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_color"
                      placeholder="Ej: Amarillo, Blanco"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_color'].hasError('required') && formVehiculo.controls['veh_color'].touched) {
                    <span class="text-danger labelError">El color es requerido.</span>
                  }
                </div>
              </div>

              <div class="row">
                <!-- Cantidad de Ocupantes -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Cantidad de Ocupantes*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-users"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_quantity_person"
                      placeholder="Ej: 4"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_quantity_person'].hasError('required') && formVehiculo.controls['veh_quantity_person'].touched) {
                    <span class="text-danger labelError">La cantidad de ocupantes es requerida.</span>
                  }
                </div>

                <!-- Conductor -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Conductor Asignado*</label>
                  <p-dropdown
                    [options]="lstDriver"
                    formControlName="driver"
                    optionLabel="dri_full_name"
                    [filter]="true"
                    filterBy="dri_full_name" 
                    [showClear]="false"
                    placeholder="Seleccione un conductor"
                    styleClass="largeInput"
                    [appendTo]="'body'"
                  >
                    <ng-template pTemplate="selectedItem" let-selectedOption>
                      <div class="d-flex align-items-center gap-2">
                        <img 
                          alt="logo"
                          src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                          [class]="'flag flag-' + selectedOption.dri_id"
                          style="width: 18px" />
                        <div>{{ selectedOption.dri_full_name }}</div>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>
              </div>
            </div>

            <!-- Tarjeta: Estado y Seguros -->
            <div class="detail-card">
              <h3 class="detail-card-title">
                <i class="pi pi-shield"></i> Estado Legal y Revisiones
              </h3>
              <div class="row">
                <!-- Inspección -->
                <div class="col-12 col-md-6 mb-3 d-flex align-items-center gap-2">
                  <p-checkbox
                    formControlName="veh_inspection"
                    [binary]="true"
                    inputId="veh_inspection"
                  />
                  <label for="veh_inspection" class="form-label-edit m-0 cursor-pointer">
                    Inspección Vehicular Aprobada*
                  </label>
                </div>

                <!-- Seguro -->
                <div class="col-12 col-md-6 mb-3 d-flex align-items-center gap-2">
                  <p-checkbox
                    formControlName="veh_secure"
                    [binary]="true"
                    inputId="veh_secure"
                  />
                  <label for="veh_secure" class="form-label-edit m-0 cursor-pointer">
                    Seguro Vigente *
                  </label>
                </div>
              </div>
            </div>

            <!-- Botón de Navegación -->
            <div class="d-flex justify-content-end mt-4">
              <p-button
                label="Continuar"
                icon="pi pi-arrow-right"
                iconPos="right"
                type="submit"
                [disabled]="formVehiculo.invalid"
                [rounded]="true"
                severity="primary"
              />
            </div>
          </form>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 2: Carga de Documentos -->
      <p-stepperPanel header="{{ step2_titulo }}">
        <ng-template pTemplate="content">
          <div class="mt-4">
            <div class="row">
              <!-- Columna Izquierda: Zona de Carga -->
              <div class="col-12 col-md-5">
                <div class="detail-card">
                  <h3 class="detail-card-title">
                    <i class="pi pi-cloud-upload"></i> Subir Documentos
                  </h3>
                  
                  <div class="mb-3">
                    <label class="form-label-edit">1. Seleccione el Tipo de Documento</label>
                    <p-dropdown
                      [options]="ltsTypeDocument"
                      [(ngModel)]="selectedTypeDocument"
                      optionLabel="typ_name"
                      placeholder="Seleccionar tipo"
                      styleClass="largeInput"
                      [appendTo]="'body'"
                    />
                  </div>

                  <div class="mb-2">
                    <label class="form-label-edit">2. Busque y Adjunte el Archivo</label>
                    <div class="logo-upload-box text-center p-3">
                      <p-fileUpload
                        #fileUpload
                        mode="basic"
                        chooseLabel="Adjuntar"
                        chooseIcon="pi pi-plus"
                        [showUploadButton]="false"
                        [showCancelButton]="false"
                        maxFileSize="7340032"
                        (onSelect)="onUploadAuto($event.files, fileUpload)"
                        accept="image/png,image/jpeg"
                        [multiple]="false"
                        styleClass="p-button-primary p-button-outlined w-100"
                      >
                      </p-fileUpload>
                      <p class="text-secondary small mt-2 mb-0">Imágenes hasta 7MB</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Columna Derecha: Tabla de Documentos Cargados -->
              <div class="col-12 col-md-7">
                <div class="detail-card h-100">
                  <h3 class="detail-card-title">
                    <i class="pi pi-file"></i> Documentos Adjuntados en Lote
                  </h3>

                  @if (ltsDocument.length === 0) {
                    <div class="text-center py-5">
                      <i class="pi pi-folder-open text-muted mb-3" style="font-size: 3rem;"></i>
                      <p class="text-muted">Ningún documento adjuntado todavía. Use el panel izquierdo para cargar.</p>
                    </div>
                  } @else {
                    <p-table
                      [value]="ltsDocument"
                      [tableStyle]="{ 'min-width': '100%' }"
                      styleClass="p-datatable-sm"
                    >
                      <ng-template pTemplate="header">
                        <tr>
                          <th id="th-img-cr">Miniatura</th>
                          <th id="th-name-cr">Archivo</th>
                          <th id="th-type-cr">Tipo</th>
                          <th id="th-act-cr" style="width: 3rem"></th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-doc let-index="rowIndex">
                        <tr>
                          <td>
                            @if (doc.filstring) {
                              <p-image
                                [src]="doc.filstring"
                                alt="Miniatura"
                                width="44"
                                height="44"
                                imageClass="rounded border shadow-sm"
                                [style]="{ 'object-fit': 'cover' }"
                              />
                            } @else {
                              <i class="pi pi-file text-indigo-500" style="font-size: 1.5rem"></i>
                            }
                          </td>
                          <td class="text-truncate font-semibold" style="max-width: 150px;">{{ doc.file.name }}</td>
                          <td>
                            <span class="status-pill status-active">
                              {{ doc.typeDocument.typ_name }}
                            </span>
                          </td>
                          <td>
                            <p-button
                              icon="pi pi-trash"
                              [rounded]="true"
                              [text]="true"
                              severity="danger"
                              (onClick)="remeveFile(index)"
                            ></p-button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  }
                </div>
              </div>
            </div>

            <!-- Botones de Navegación -->
            <div class="d-flex justify-content-between mt-4">
              <p-button label="Atrás" icon="pi pi-arrow-left" [outlined]="true" severity="secondary" [rounded]="true" (onClick)="back()" />
              <p-button
                label="Guardar y Registrar Vehículo"
                icon="pi pi-save"
                [rounded]="true"
                severity="primary"
                (onClick)="createVehicle()"
              />
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 3: Hecho / Éxito -->
      <p-stepperPanel header="{{ step3_titulo }}">
        <ng-template pTemplate="content">
          <div class="success-container">
            <div class="success-icon-wrapper">
              <i class="pi pi-check"></i>
            </div>
            <h3 class="success-title">¡Vehículo Registrado con Éxito!</h3>
            <p class="success-subtitle">
              El vehículo ha sido almacenado en el sistema correctamente y se encuentra listo para operar. Puede asociar conductores o validar los documentos cargados en cualquier momento.
            </p>
            
            <div class="d-flex justify-content-center gap-3">
              <p-button
                label="Registrar Otro Vehículo"
                icon="pi pi-plus"
                [rounded]="true"
                severity="primary"
                [outlined]="true"
                (onClick)="backStart()"
              />
              <p-button
                label="Volver al Listado"
                icon="pi pi-list"
                [rounded]="true"
                severity="primary"
                routerLink="/admin/vehicle"
              />
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

    </p-stepper>
  </div>
</div>
